import { Box, Stack } from '@mui/material';

import { EllipsisTypography } from '@components/templates/learningPath/learningPathDetail/LearningPathStep/LearningPathStepDetail/LearningPathStepDetailSection/LearningPathCourseCard/style';
import { getAssetUrl } from '@helpers/utils';

type LearningPathCardProps = {
  learningPathname: string;
  imageSrc: string;
  onClick: () => void;
};
const LearningPathCard = ({ learningPathname, imageSrc, onClick }: LearningPathCardProps) => {
  return (
    <Box
      display="flex"
      height="100%"
      p={{
        xs: 3,
        md: 2,
      }}
      gap={{
        xs: 3,
        md: 4,
      }}
      borderRadius={4}
      bgcolor="background.paper"
      width="100%"
      onClick={onClick}
      sx={{
        cursor: 'pointer',
      }}
      flexDirection={{
        xs: 'column',
        md: 'row',
      }}
      justifyContent={{
        xs: 'start',
        md: 'flex-start',
      }}
    >
      <Box
        component="img"
        src={imageSrc ?? getAssetUrl('thumbnail-course-card.jpg')}
        minWidth={{
          xs: '100%',
          md: 'auto',
        }}
        minHeight={{
          xs: 'auto',
          md: 171,
        }}
        height={{
          xs: 'auto',
          md: 171,
        }}
        borderRadius={2}
      />
      <Box flex={1} overflow="hidden">
        <Stack height="100%" justifyContent="space-between">
          <EllipsisTypography
            width="100%"
            variant="h4"
            sx={{
              wordBreak: 'break-all',
              WebkitLineClamp: {
                xs: 2,
                md: 3,
              },
            }}
          >
            {learningPathname}
          </EllipsisTypography>
        </Stack>
      </Box>
    </Box>
  );
};

export default LearningPathCard;
